import { dataCivil, diaDaSemana, paraISO, somaDias } from "./data.js";
/**
 * Feriados BANCARIOS nacionais. O que importa para vencimento de tributo
 * federal e o dia em que ha expediente bancario, nao a lista de feriados civis.
 *
 * Nao inclui feriados estaduais/municipais: o vencimento do carne-leao e
 * federal e segue o calendario nacional.
 */
/** Domingo de Pascoa (algoritmo gregoriano anonimo / Meeus). */
export function pascoa(ano) {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;
    return dataCivil(ano, mes, dia);
}
const cache = new Map();
export function feriadosNacionais(ano) {
    const memo = cache.get(ano);
    if (memo)
        return memo;
    const p = pascoa(ano);
    const fixos = [
        dataCivil(ano, 1, 1), // Confraternizacao Universal
        dataCivil(ano, 4, 21), // Tiradentes
        dataCivil(ano, 5, 1), // Dia do Trabalho
        dataCivil(ano, 9, 7), // Independencia
        dataCivil(ano, 10, 12), // Nossa Senhora Aparecida
        dataCivil(ano, 11, 2), // Finados
        dataCivil(ano, 11, 15), // Proclamacao da Republica
        dataCivil(ano, 11, 20), // Consciencia Negra (nacional desde 2024, Lei 14.759/2023)
        dataCivil(ano, 12, 25), // Natal
        // 31/12: nao ha expediente bancario. Tratado como nao-util de forma
        // conservadora — antecipa o vencimento da competencia de novembro.
        // TODO(contador): confirmar se a RFB considera 31/12 dia util para
        //   fins de "ultimo dia util do mes". Na duvida, antecipar e o seguro.
        dataCivil(ano, 12, 31),
    ];
    const moveis = [
        somaDias(p, -48), // Segunda de Carnaval
        somaDias(p, -47), // Terca de Carnaval
        somaDias(p, -2), // Sexta-feira Santa
        somaDias(p, 60), // Corpus Christi
    ];
    // Quarta-feira de Cinzas (p-46) tem expediente a partir das 12h:
    // conta como dia util.
    const set = new Set([...fixos, ...moveis].map(paraISO));
    cache.set(ano, set);
    return set;
}
export function ehDiaUtil(d) {
    const dow = diaDaSemana(d);
    if (dow === 0 || dow === 6)
        return false;
    return !feriadosNacionais(d.ano).has(paraISO(d));
}
/** Recua ate encontrar um dia util (inclusive a propria data). */
export function diaUtilAnterior(d) {
    let cur = d;
    for (let i = 0; i < 15; i++) {
        if (ehDiaUtil(cur))
            return cur;
        cur = somaDias(cur, -1);
    }
    throw new Error(`nenhum dia util encontrado a partir de ${paraISO(d)}`);
}
//# sourceMappingURL=feriados.js.map